<template>
  <div class="reportTable">
    <section ref="print">
      <div class="title">
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <!-- <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li> -->
        </ul>
      </div>
      <!-- 图表 -->
      <div>
        <div>
          <div
            id="main"
            style="width: 100%; height: 400px; background-color: #ffffff"
          ></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
import { getDay } from "../../utils/reg";
import * as echarts from "echarts";
export default {
  data() {
    return {
      preArrivalList: [],
      // 记录
      record: "",
      room: "",
      total: "",
      userName: localStorage.getItem("cname"),
      allPage: 0,
      // 查询日期
      queryDate: "",
      piesource: "",
      beginTime: "",
      endTime: "",
      list1: [],
      list2: [],
      list3: [],
    };
  },
  mounted() {},
  created() {
    this.$parent.searchMonth = new Date();
    this.$parent.chaxunvib = false;
    this.getData();
  },
  methods: {
    doserach() {
      this.getData();
    },
    // 查询
    getData() {
      this.$parent.searchMonth = this.$moment(this.$parent.searchMonth).format(
        "YYYY-MM-DD"
      );
      var year = this.$parent.searchMonth.substring(0, 4);
      var month = this.$parent.searchMonth.substring(5, 7);
      var day = getDay(year, month);
      this.beginTime = year + "-" + month + "-01";
      this.endTime = year + "-" + month + "-" + day;
      getRequest("/xcxReport/sexAndAge", {
        // beginTime: this.beginTime,
        // endTime: this.endTime,
      }).then((res) => {
        if (res.status == 200) {
          let list = res.data.list;
          this.list1 = res.data.years;
          let listm = [];
          let listw = [];
          list.forEach((item) => {
            item.sexList.forEach((item2) => {
              if (item2.sex == 1) {
                listm.push(item2.nums);
              } else if (item2.sex == 0) {
                listw.push(item2.nums);
              }
            });
            if (listm.length > listw.length) {
              listw.push(0);
            } else if (listm.length < listw.length) {
              listm.push(0);
            }
          });

          this.list2 = listm;
          this.list3 = listw;
          this.getPie();
        } else {
          that.$mymessage({
            content: res.message,
            type: "error",
            time: 2000,
            hasClose: true,
          });
        }
      });
    },
    // 图形
    getPie() {
      // 绘制图表
      var myChart = echarts.init(document.getElementById("main"));
      // 指定图表的配置项和数据
      var option = {
        //标题
        color: ["#fc8452", "#91cc75", "#fac858", "#ee6666"],
        title: {
          text: "入住",
          subtext: "客户性别、年龄分析",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["性别", "年龄段"],
          orient: "vertical",
          left: "right",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        xAxis: {
          type: "category",
          data: this.list1,
        },
        series: [
          {
            name: "男",
            type: "bar",
            data: this.list2,
            label: {
              show: true,
            },
          },
          {
            name: "女",
            type: "bar",
            data: this.list3,
            label: {
              show: true,
            },
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style scoped>
#main {
  margin-top: 30px;
}
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 40px;
  height: 62px;
}
.title > ul {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 62px;
}
>>> canvas {
  background-color: #ffff;
}
</style>
